import EngagementForm from 'app/Apps/RelationshipsManagement/Engagement/EngagementForm'
import {
    EngagementType,
} from 'app/Apps/RelationshipsManagement/Engagement/engagement.types'

export default function EngagementDemoOverview({
    data, onSuccess, onCancel,
}: {
    data: EngagementType,
    onSuccess: () => void,
    onCancel: () => void,
}) {
    return (
        <EngagementForm
            data={data as EngagementType}
            onSuccess={onSuccess}
            onCancel={onCancel}
            disabled
        />
    )
}
